import auth from './reducers/auth';
import { combineReducers } from 'redux';
import common from './reducers/common';
import dashboard from './reducers/dashboard';
import signin from './reducers/signin';
import bookevent from './reducers/bookevent';

export default combineReducers({
  auth,
  common,
  dashboard,
  signin,
  bookevent
});



// WEBPACK FOOTER //
// ./src/reducer.js